import {
  COMMISSION_DATA_EXTERNAL,
  COMMISSION_DATA_INTERNAL,
} from "./commission-data";

function getCustoFinanceiro(prazo, preco_venda) {
  if (prazo <= 0) return 0;

  return ((((3 / 30) * prazo) / 100) * preco_venda).toFixed(5);
}

function getCustoEntregaCliente(company_id, custo_km, km_idv, custo_partida) {
  if (typeof custo_km === "string" && custo_km.includes(","))
    custo_km.replaceAll(",", ".");
  if (typeof custo_partida === "string" && custo_partida.includes(","))
    custo_partida.replaceAll(",", ".");

  let custo_caminhao = 10000;

  //if ([1, 2, 3].includes(+company_id)) custo_caminhao = 12000;

  return (
    (parseFloat(custo_km) * parseFloat(km_idv) + parseFloat(custo_partida)) /
    custo_caminhao
  ).toFixed(4);
}

function getK(preco_venda, preco_compra, icms, cec, custo_financeiro) {
  return (preco_venda - preco_compra - icms - cec - custo_financeiro).toFixed(
    4
  );
}

function getPrecoMinimo(k, icms, cec, custo_financeiro) {
  return +(k + icms + cec + custo_financeiro).toFixed(5);
}

function getKpercent(k, preco_venda) {
  return ((k / preco_venda).toFixed(5) * 100).toFixed(2);
}

function getIcmsArlaSameState(preco_venda, preco_compra) {
  const lucroBruto = preco_venda - preco_compra;

  return (lucroBruto * 0.18).toFixed(4);
}

function getIcmsArlaDifferentState(preco_compra) {
  const priceWithIcms = ((preco_compra * 0.88) / 0.82).toFixed(4);
  return (priceWithIcms - preco_compra).toFixed(4);
}

function getInternalCommission(
  quantidade,
  k,
  k_percentual,
  produto,
  preco_venda
) {
  k_percentual = Number(k_percentual);
  const multiply = quantidade * k;

  if (produto === 3) {
    if (k_percentual > 0 && k_percentual <= 5) {
      return (
        multiply * COMMISSION_DATA_INTERNAL.ARLA.first_range.indice
      ).toFixed(2);
    }
    if (k_percentual > 5 && k_percentual <= 15) {
      return (
        multiply * COMMISSION_DATA_INTERNAL.ARLA.second_range.indice
      ).toFixed(2);
    }
    if (k_percentual > 15 && k_percentual < 1000) {
      return (
        multiply * COMMISSION_DATA_INTERNAL.ARLA.third_range.indice
      ).toFixed(2);
    }
  }

  if ([1, 2, 4, 5].includes(produto)) {
    if (k_percentual > 0 && k_percentual <= 3.5) {
      return (
        multiply * COMMISSION_DATA_INTERNAL.DIESEL.first_range.indice
      ).toFixed(2);
    }
    if (k_percentual > 3.5 && k_percentual <= 5.5) {
      return (
        multiply * COMMISSION_DATA_INTERNAL.DIESEL.second_range.indice
      ).toFixed(2);
    }
    if (k_percentual > 5.5 && k_percentual <= 7) {
      return (
        multiply * COMMISSION_DATA_INTERNAL.DIESEL.third_range.indice
      ).toFixed(2);
    }
    if (k_percentual > 7 && k_percentual < 1000) {
      return (
        multiply * COMMISSION_DATA_INTERNAL.DIESEL.fourth_range.indice
      ).toFixed(2);
    }
  }
}

function getExternalCommission(
  quantidade,
  k,
  k_percentual,
  produto,
  preco_venda
) {
  const multiply = quantidade * k;
  if (produto === 3) {
    if (k_percentual > 0 && k_percentual < 5) {
      return (
        multiply * COMMISSION_DATA_EXTERNAL.ARLA.first_range.indice
      ).toFixed(2);
    }
    if (k_percentual > 5.01 && k_percentual < 15) {
      return (
        multiply * COMMISSION_DATA_EXTERNAL.ARLA.second_range.indice
      ).toFixed(2);
    }
    if (k_percentual > 15 && k_percentual < 1000) {
      return (
        multiply * COMMISSION_DATA_EXTERNAL.ARLA.third_range.indice
      ).toFixed(2);
    }
  }

  if ([1, 2, 4, 5].includes(produto)) {
    if (k_percentual > 0 && k_percentual < 3.5) {
      return (
        multiply * COMMISSION_DATA_EXTERNAL.DIESEL.first_range.indice
      ).toFixed(2);
    }
    if (k_percentual > 3.51 && k_percentual < 5.5) {
      return (
        multiply * COMMISSION_DATA_EXTERNAL.DIESEL.second_range.indice
      ).toFixed(2);
    }
    if (k_percentual > 5.51 && k_percentual < 7) {
      return (
        multiply * COMMISSION_DATA_EXTERNAL.DIESEL.third_range.indice
      ).toFixed(2);
    }
    if (k_percentual > 7.01 && k_percentual < 1000) {
      return (
        multiply * COMMISSION_DATA_EXTERNAL.DIESEL.fourth_range.indice
      ).toFixed(2);
    }
  }
}

// MG = 11, SP = 26, GO = 9

function correctHourAndMinutes() {
  const date = new Date();
  let seconds = date.getSeconds();
  let minutes = date.getMinutes();
  let hours = date.getHours();

  if (seconds < 10) seconds = `0${seconds}`;
  if (minutes < 10) minutes = `0${minutes}`;
  if (hours < 10) hours = `0${hours}`;

  return `${hours}:${minutes}:${seconds}`;
}

function correctDate() {
  const date = new Date();
  let day = date.getDate();
  let month = date.getMonth();
  let year = date.getFullYear();

  if (day < 10) day = `0${date.getDate()}`;
  if (month < 10) month = `0${month + 1}`;
  if (month >= 10) month = `${month + 1}`;
  return `${year}-${month}-${day}`;
}

export {
  getCustoFinanceiro,
  getCustoEntregaCliente,
  getK,
  getIcmsArlaSameState,
  getIcmsArlaDifferentState,
  getPrecoMinimo,
  getKpercent,
  correctHourAndMinutes,
  correctDate,
  getInternalCommission,
  getExternalCommission,
};
